var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"value":_vm.visibility,"value-comparator":function (v) { return v; },"label":_vm.toggleLabel,"loading":_vm.loading},on:{"change":_vm.toggleVisibility}})}
var staticRenderFns = []

export { render, staticRenderFns }